
export default {
    name: "post",
    props: ['simPost']
}

